<template>
  <v-container fluid grid-list-lg>
    <Create
      :createDialog="createDialog"
      @close="createDialog = false"
      @submit="getList"
    ></Create>
    <Edit
      :editDialog="editDialog"
      @close="editDialog = false"
      @submit="getList"
      :editCurriculum="selectedCurriculum"
    ></Edit>
    <AssignSubject :editDialog="assignSubjectDialog" @close="assignSubjectClose" @submit="assigntSubjectSubmit"
      :selectedCurriculum="selectedCurriculum"></AssignSubject>
    <v-card :loading="loading" outlined>
      <ListTitle
        :showBackButton="true"
        :access="checkRightStatus(45)"
        title="Curriculum"
        @add="add"
      />

      <v-card-title>
        <v-flex xs12 sm4>
          <v-text-field
            v-model="search"
            outlined
            prepend-inner-icon="search"
            rounded
            dense
            label="Search"
            single-line
            hide-details
            clearable
          ></v-text-field>
        </v-flex>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="curriculums"
        :search="search"
        :loading="loading"
        :sort-by="sortBy"
        :page.sync="page"
        :items-per-page="itemsPerPage"
      >
        <template v-slot:item="{ item }">
          <tr class="pointer">
            <td class="text-left">{{ item.name }}</td>
            <td class="text-left">
              <div v-if="item.subjectMeta && item.subjectMeta.subjects">{{ item.subjectMeta.subjects.length }}</div>
              <div v-else>0</div>
            </td>
            <td class="justify-end align-center text-right">
              <v-menu bottom left offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" icon>
                    <v-icon>more_vert</v-icon>
                  </v-btn>
                </template>
                <v-list class="menu-button">
                  <v-list-item
                    @click="assignSubject(item)"
                  >
                    <v-list-item-title>Assign Subject</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="checkRightStatus(47)"
                    @click="editCurriculum(item)"
                  >
                    <v-list-item-title>Edit</v-list-item-title>
                  </v-list-item>
                  <v-divider></v-divider>
                  <v-list-item
                    v-if="checkRightStatus(48)"
                    @click="deleteCurriculum(item.id)"
                  >
                    <v-list-item-title>Delete</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning"
          >Your search for "{{ search }}" found no results.</v-alert
        >
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import curriculumService from "../service";
import { mapGetters } from "vuex";

const Create = () => import("./Create");
const Edit = () => import("./Edit");
const AssignSubject = () =>
  import("@/modules/ReportCard/Curriculums/components/AssignSubject.vue");
export default {
  name: "curriculum-list",
  data() {
    return {
      createDialog: false,
      editDialog: false,
      selectedCurriculum: null,
      assignSubjectDialog: false,
      headers: [
        {
          text: "Title",
          align: "left",
          value: "name",
          sortable: true,
        },
        {
          text: "Subject Count",
          align: "left",
          value: "subject",
          sortable: true,
        },
        {
          text: "",
          value: "action",
          sortable: false,
        },
      ],
      curriculums: [],
      search: null,
      loading: true,
      page: 1,
      sortBy: "createdAt",
      pageCount: 0,
      itemsPerPage: 10,
    };
  },
  created() {
    this.getList();
    document.title = "taleem - Curriculum List";
  },
  components: {
    Create,
    Edit,
    AssignSubject
  },
  computed: {
    ...mapGetters("global", ["currentUser", "checkRightStatus"]),
  },
  methods: {
    add() {
      this.createDialog = !this.createDialog;
    },
    getList() {
      this.loading = true;
      this.editDialog = false 
      this.createDialog = false
      return curriculumService.getAll().then((response) => {
        console.log('response', response)
        this.loading = false;
        this.curriculums = response.data;
        return response;
      });
    },
    editCurriculum(curriculum) {
      this.selectedCurriculum = curriculum;
      this.editDialog = !this.editDialog;
    },
    deleteCurriculum(id) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#B71C1C",
        cancelButtonColor: "#43A047",
        cancelButtonText: "No",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.value) {
          curriculumService.delete(id).then((response) => {
            if (response.data) {
              this.$swal("Deleted!", "Curriculum has been deleted.", "success");
              this.getList();
            }
          });
        }
      });
    },
    assignSubject(curriculum){
      this.selectedCurriculum = curriculum;
      this.assignSubjectDialog = !this.assignSubjectDialog;
    },
    assignSubjectClose(){
      this.selectedCurriculum = null;
      this.assignSubjectDialog = !this.assignSubjectDialog;
    },
    assigntSubjectSubmit(){
      this.assignSubjectDialog = !this.assignSubjectDialog;
      this.selectedCurriculum = null;
      this.getList();
    }
  },
};
</script>
